<div class="graph">
  <div #area class="graph__area" [style.height]="altura()">
    <svg
      class="graph__svg"
      [class.graph__svg--arrastando]="arrastandoNo()"
      role="group"
      aria-label="Mapa societário: use Tab para percorrer as empresas e pessoas, Enter ou Espaço para ver o detalhe"
      (wheel)="aoRolar($event)"
      (pointerdown)="iniciarArrasto($event)"
      (pointermove)="arrastar($event)"
      (pointerup)="soltar()"
      (pointercancel)="soltar()">
      @for (a of arestasTela(); track a.chave) {
        <line
          [attr.x1]="a.x1"
          [attr.y1]="a.y1"
          [attr.x2]="a.x2"
          [attr.y2]="a.y2"
          [attr.stroke]="cores.aresta"
          stroke-width="1.2" />
        @if (a.seta) {
          <polygon [attr.points]="a.seta" [attr.fill]="cores.aresta" />
        }
      }

      @for (n of nosTela(); track n.no.id) {
        <g class="graph__node">
          <circle
            [attr.cx]="n.sx"
            [attr.cy]="n.sy"
            [attr.r]="n.r"
            [attr.fill]="n.cor"
            stroke="#ffffff"
            stroke-width="2" />
          @if (n.alerta) {
            <circle
              [attr.cx]="n.sx"
              [attr.cy]="n.sy"
              [attr.r]="n.r + 2.5"
              fill="none"
              [attr.stroke]="cores.alerta"
              stroke-width="2" />
          }
          <rect
            class="graph__label-bg"
            [attr.x]="n.sx + n.r + 3"
            [attr.y]="n.sy - fonte * 0.65"
            [attr.width]="n.larguraRotulo + 4"
            [attr.height]="fonte * 1.3" />
          <text
            class="graph__label"
            [attr.x]="n.sx + n.r + 5"
            [attr.y]="n.sy"
            dominant-baseline="middle">
            {{ n.rotulo }}
          </text>
          <!-- Área de toque por cima de tudo, como o `nodePointerAreaPaint` do Dossiê. -->
          <circle
            class="graph__hit"
            [attr.cx]="n.sx"
            [attr.cy]="n.sy"
            [attr.r]="areaDeToque(n)"
            tabindex="0"
            role="button"
            [attr.aria-label]="n.no.rotulo"
            (pointerdown)="iniciarArrastoNo(n, $event)"
            (mouseenter)="entrarNo(n)"
            (mouseleave)="sairNo()"
            (focus)="entrarNo(n)"
            (blur)="sairNo()"
            (click)="clicarNo(n, $event)"
            (keydown.enter)="clicarNo(n, $event)"
            (keydown.space)="$event.preventDefault(); clicarNo(n, $event)" />
        </g>
      }
    </svg>

    @if (tooltip(); as t) {
      <div class="graph__tooltip" [style.left.px]="t.sx" [style.top.px]="t.sy + t.r + 14">
        {{ t.no.rotulo }}
      </div>
    }
  </div>

  @if (popover(); as p) {
    <div class="graph__popover-anchor" [style.left.px]="p.sx" [style.top.px]="p.sy">
      <div
        class="pop"
        role="dialog"
        [attr.aria-label]="p.no.rotulo"
        (click)="$event.stopPropagation()">
        <div class="pop__head">
          <div class="pop__type">
            <span class="pop__dot" [style.background]="p.cor"></span>
            <span class="pop__eyebrow">{{ tipoRotulo(p.no) }}</span>
          </div>
          <button type="button" class="pop__close" aria-label="Fechar" (click)="fecharPopover()">
            x
          </button>
        </div>
        <h4 class="pop__title">{{ p.no.rotulo }}</h4>
        <dl class="pop__rows">
          @if (p.no.tipo === 'empresa') {
            @if (p.no.cnpj) {
              <div class="pop__row">
                <dt>CNPJ</dt>
                <dd class="pop__mono">{{ p.no.cnpj | vaultMaskCnpj }}</dd>
              </div>
            }
            @if (p.no.situacao) {
              <div class="pop__row">
                <dt>Situação</dt>
                <dd [class.pop__alert]="p.alerta">{{ p.no.situacao }}</dd>
              </div>
            }
            @if (p.no.municipio || p.no.uf) {
              <div class="pop__row">
                <dt>Local</dt>
                <dd>{{ p.no.municipio }}{{ p.no.municipio && p.no.uf ? '/' : '' }}{{ p.no.uf }}</dd>
              </div>
            }
            @if (p.no.nSocios !== null && p.no.nSocios !== undefined) {
              <div class="pop__row">
                <dt>Sócios (QSA)</dt>
                <dd>{{ p.no.nSocios }}</dd>
              </div>
            }
          } @else {
            @if (p.no.documento) {
              <div class="pop__row">
                <dt>Documento</dt>
                <dd class="pop__mono">{{ p.no.documento }}</dd>
              </div>
            }
            @if (p.no.qualificacao) {
              <div class="pop__row">
                <dt>Qualificação</dt>
                <dd>{{ p.no.qualificacao }}</dd>
              </div>
            }
            @if (p.no.dataEntrada) {
              <div class="pop__row">
                <dt>Entrada</dt>
                <dd>{{ p.no.dataEntrada | vaultDate }}</dd>
              </div>
            }
            @if (p.no.nEmpresas !== null && p.no.nEmpresas !== undefined) {
              <div class="pop__row">
                <dt>Empresas</dt>
                <dd>{{ p.no.nEmpresas }} {{ p.no.nEmpresas === 1 ? 'empresa' : 'empresas' }}</dd>
              </div>
            }
          }
        </dl>
      </div>
    </div>
  }
</div>
